// Approver user reference — display name + submit payload user id.
interface ApproverUserRef {
  id: number
  firstName: string
  lastName: string
}

export interface SessionApproverChoiceConstructor {
  id: number // approver record id — submitted on the bill payload
  user: ApproverUserRef
}

export class SessionApproverChoice {
  readonly id: number
  readonly user: ApproverUserRef

  constructor(data: SessionApproverChoiceConstructor) {
    this.id = data.id
    this.user = data.user
  }

  // Approver select option label (BHV-046)
  get userFullName(): string {
    return `${this.user.firstName} ${this.user.lastName}`
  }
}
